<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
    <div class="min-h-screen bg-gray-50 p-6">
    <!-- 筛选区域 -->
    <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
    <div class="flex items-center space-x-6">
    <div class="relative w-64">
    <button @click="toggleLocationDropdown" class="w-full flex items-center justify-between px-4 py-2 border rounded-lg bg-white text-gray-700 hover:bg-gray-50">
    <span>{{ selectedSupplier.name || '选择供应商' }}</span>
    <i class="fas fa-chevron-down text-gray-400"></i>
    </button>
    <div v-if="showSupplierDropdown" class="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg">
    <div v-for="location in supply" :key="location" @click="selectSupplier(location)" class="px-4 py-2 hover:bg-gray-100 cursor-pointer">
    {{ location.name }}
    </div>
    </div>
    </div>
    <div>只统计已完成订单</div>
    <div class="relative w-64">
        <div class="relative">
        <input
            type="text"
            v-model="productSearch"
            @focus="showProductDropdown = true"
            class="w-full px-4 py-2 border rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            :placeholder="selectedProduct.name  || '选择商品'"
        />
        <i class="fas fa-search absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
        </div>
        <div v-if="showProductDropdown" class="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
        <div 
            v-for="product in filteredProducts" 
            :key="product" 
            @click="selectProduct(product)" 
            class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
        >
            {{ product.name }}
        </div>
        <div v-if="filteredProducts.length === 0" class="px-4 py-2 text-gray-500">
            未找到相关商品
        </div>
        </div>
        </div>
    <div class="flex items-center space-x-4">
    <button @click="setDateRange('today')" :class="{'bg-blue-50 text-blue-600': dateRange === 'today'}" class="px-4 py-2 rounded-lg hover:bg-gray-100 !rounded-button">今日</button>
    <button @click="setDateRange('week')" :class="{'bg-blue-50 text-blue-600': dateRange === 'week'}" class="px-4 py-2 rounded-lg hover:bg-gray-100 !rounded-button">本周</button>
    <button @click="setDateRange('month')" :class="{'bg-blue-50 text-blue-600': dateRange === 'month'}" class="px-4 py-2 rounded-lg hover:bg-gray-100 !rounded-button">本月</button>
    </div>
    <button @click="search" class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 !rounded-button whitespace-nowrap">
    <i class="fas fa-search mr-2"></i>查询
    </button>
    </div>
    </div>
    <!-- 数据概览卡片 -->
    <div class="grid grid-cols-4 gap-6 mb-6">
    <div v-for="(stat, index) in stats" :key="index" class="bg-white rounded-lg shadow-sm p-6">
    <div class="text-gray-600 mb-2">{{ stat.title }}</div>
    <div class="flex items-end space-x-2">
    <div class="text-2xl font-semibold">{{ stat.value }}</div>
    <div :class="stat.trend > 0 ? 'text-green-500' : 'text-red-500'" class="flex items-center">
    <i :class="stat.trend > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" class="fas text-sm mr-1"></i>
    {{ Math.abs(stat.trend) }}%
    </div>
    </div>
    </div>
    </div>
    <!-- 图表区域 -->
    <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
    <div class="flex justify-between items-center mb-6">
    <h2 class="text-lg font-medium">销售趋势</h2>
    <div class="flex space-x-4">
    <button @click="chartType = 'line'" :class="{'bg-blue-50 text-blue-600': chartType === 'line'}" class="px-4 py-2 rounded-lg hover:bg-gray-100 !rounded-button">折线图</button>
    <!-- <button @click="chartType = 'bar'" :class="{'bg-blue-50 text-blue-600': chartType === 'bar'}" class="px-4 py-2 rounded-lg hover:bg-gray-100 !rounded-button">柱状图</button> -->
    </div>
    </div>
    <div ref="chartRef" style="height: 400px"></div>
    </div>
    <!-- 数据明细表格 -->
    <div class="bg-white rounded-lg shadow-sm p-6">
    <div class="flex justify-between items-center mb-6">
    <h2 class="text-lg font-medium">销售明细</h2>
    <button class="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-lg !rounded-button">
    <i class="fas fa-download mr-2"></i>导出数据
    </button>
    </div>
    <table class="w-full">
    <thead>
    <tr class="border-b">
    <th v-for="header in tableHeaders" :key="header" class="pb-4 text-left text-gray-600">{{ header }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(row, index) in tableData" :key="index" class="border-b">
    <td v-for="(value, key) in row" :key="key" class="py-4">{{ value }}</td>
    </tr>
    </tbody>
    </table>


    
    <div class="pagination">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background :current-page="curPage"
            :page-sizes="[20, 100,500, 1000]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalDataNumber"></el-pagination>
        </div>
  
    </div>
    </div>
    </template>
    <script>
    import * as echarts from 'echarts';
    import StatisticsApi from '@/api/statistics.js';
    import Warehouse_managementApi from '@/api/warehouse_management.js';

    export default {
    data() {
    return {
    showSupplierDropdown: false,
    showProductDropdown: false,
    selectedProduct: '',
    locations: ['广州批发中心', '深圳批发中心', '东莞批发中心', '佛山批发中心', '中山批发中心'],
    products: ['高级羊毛衫', '真丝连衣裙', '休闲运动裤', '棉麻衬衫', '时尚牛仔裤', '运动夹克', '商务西装', '针织开衫', '休闲polo衫', '复古卫衣'],
    dateRange: 'today',
    chartType: 'line',
    stats: [
  
    ],
    tableHeaders: ['日期', '商品名称', '商品分类', '销售数量', '销售金额'],
    tableData: [

    ],
    currentPage: 1,
    totalPages: 10,
    totalRecords: 126,
    chart: null,

    tableData: [
        ],
          /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form:{},
        productSearch:"",


        selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        startDate: '',
        endDate: '',
        supply:[],
        form:{
            startDate: '',
            endDate: '',
        },
        isuse:0,
    };
    },
    computed: {
  filteredProducts() {
    if (!this.productSearch) return this.products;
    const search = this.productSearch;
    return this.products.filter(product => 
      product.name.includes(search)
    );
  }
},
    mounted() {
              /*获取数据*/
      var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
      self.getSupplys()
 
      self.search();

    },
    methods: {
        getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
           
                })
                .catch(error => {
                });
        },
        toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.form.supply_id = supplier.supply_id
      },
      handleDateChange() {
        if (this.startDate && this.endDate) {
          this.refreshData();
        }
      },
      toggleWholesaleDropdown() {
        this.showWholesaleDropdown = !this.showWholesaleDropdown;
        this.showTimeDropdown = false;
        this.showStoreDropdown = false;
      },
      toggleStoreDropdown() {
        if (this.selectedWholesale) {
          this.showStoreDropdown = !this.showStoreDropdown;
          this.showWholesaleDropdown = false;
        }
      },
        search(){
            this.getProductList()
            this.getSalesOverview()
            this.getSalesTrend()
            this.getSalesDetail()
        },
            /*选择第几页*/
        handleCurrentChange(val) {
            this.curPage = val
            this.getSalesDetail()
            },
            /*每页多少条*/
            handleSizeChange(val) {
            this.curPage = 1
            this.pageSize = val
            this.getSalesDetail()
        },
        getProductList(){
            let self = this;
            StatisticsApi.getProductList(self.form, true)
            .then(res => {
                self.products  = res.data
            })
            .catch(error => {});
        },
        getSalesOverview(){
            let self = this;
            let Params = self.form
            Params.product_id = self.selectedProduct.product_id
            Params.date_range = self.dateRange
            StatisticsApi.getSalesOverview(Params, true)
            .then(res => {
                self.stats  = res.data
            })
            .catch(error => {});
        },
        getSalesTrend(){
            let self = this;
            self.chart = echarts.init(self.$refs.chartRef);


            let Params = self.form
            Params.product_id = self.selectedProduct.product_id
            Params.date_range = self.dateRange
            StatisticsApi.getSalesTrend(Params, true)
            .then(res => {
    
                self.chart.setOption(res.data);
            })
            .catch(error => {});
        },


        getSalesDetail(){
            let self = this;
            let Params = self.form
            Params.page = self.curPage
            Params.list_rows = self.pageSize
            Params.product_id = self.selectedProduct.product_id
            Params.date_range = self.dateRange
            StatisticsApi.getSalesDetail(Params, true)
            .then(res => {
                self.tableData  = res.data.list
                self.totalDataNumber = res.data.total;
            })
            .catch(error => {});
        },













    toggleLocationDropdown() {
    this.showSupplierDropdown = !this.showSupplierDropdown;
    this.showProductDropdown = false;
    },
    toggleProductDropdown() {
    this.showProductDropdown = !this.showProductDropdown;
    this.showSupplierDropdown = false;
    },
    selectProduct(product) {
            this.selectedProduct = product;
            this.productSearch = '';
            this.showProductDropdown = false;
},
    setDateRange(range) {
        this.dateRange = range;
        console.log('range',range);
    },
    initChart() {

    const option = {
    animation: false,
    tooltip: {
    trigger: 'axis'
    },
    legend: {
    data: ['商品销售额', '销售数量']
    },
    grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
    },
    xAxis: {
    type: 'category',
    boundaryGap: false,
    data: ['1月10日', '1月11日', '1月12日', '1月13日', '1月14日', '1月15日', '1月16日']
    },
    yAxis: [
    {
    type: 'value',
    name: '商品销售额',
    axisLabel: {
    formatter: '¥{value}'
    }
    },
    {
    type: 'value',
    name: '销售数量',
    axisLabel: {
    formatter: '{value}件'
    }
    }
    ],
    series: [
    {
    name: '商品销售额',
    type: this.chartType,
    data: [15000, 18000, 22000, 20000, 24000, 25000, 28000],
    yAxisIndex: 0
    },
    {
    name: '销售数量',
    type: this.chartType,
    data: [150, 180, 220, 200, 240, 250, 280],
    yAxisIndex: 1
    }
    ]
    };
    this.chart.setOption(option);
    }
    },
    watch: {
    chartType() {
    this.getSalesTrend();
    }
    }
    };
    </script>
    <style scoped>
    .custom-table {
    border-collapse: separate;
    border-spacing: 0;
    }
    </style>
    


// WEBPACK FOOTER //
// src/views/statistics/productsales/indexx.vue